var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup1Updated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95579 23L5.21479 20.5357L11.3418 17.25L11.6871 13.9643L1.89947 4.92857L2.24481 1.64286H7.2005L7.37317 0H14.8067H22.2403L22.0676 1.64286H27.0233L26.6779 4.92857L14.9909 13.9643L14.6456 17.25L20.0819 20.5357L19.8229 23H12.3893H4.95579ZM7.85378 3.28571H4.54999L4.46365 4.10714L7.50844 6.57143L7.85378 3.28571ZM21.069 3.28571H24.3728L24.2864 4.10714L20.7236 6.57143L21.069 3.28571Z",
    fill: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0294 1.7641L15.311 1.7641L14.3111 11.3123L12.7056 11.3123L13.4661 4.05961H13.452L12.1987 5.24257H12.1846L12.3676 3.49629L14.0294 1.7641Z",
    fill: "#161C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup1Updated);
export default __webpack_public_path__ + "static/media/cup-1-updated.9298bffd16f738a3ca1adf7ce4cd2135.svg";
export { ForwardRef as ReactComponent };